'use client';
import {memo as Memo, useEffect, useRef} from 'react';

//* HOC's
import { withDataContext, withUIContext } from '@/context';

//* Style
import PrivacyPolicyStyle from './PrivacyPolicyStyle';

//* Component's
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';
import Container from '@/components/common/Container';

const PrivacyPolicyTemplate = Memo(() => {

	return (
		<Page className={'privacy-policy'}>
			<PrivacyPolicyStyle >
				<Container section>

					<Text className={'h1 text-center'}>Privacy Policy</Text>

					 <Text className={'p text-center m-t-1'}>Updated at March 12th, 2025</Text>

					 <Text className={'p m-t-2'}>https://sundaytowers.am/ (“we,”
“our,” or “us”) is committed to protecting your privacy. This Privacy Policy
explains how your personal information is collected, used,
and disclosed by https://sundaytowers.am/ .</Text>

					 <Text className={'p m-t-1'}>This Privacy Policy applies to
our website, and its associated subdomains (collectively, our “Service”)
alongside our application, https://sundaytowers.am/. By accessing or using our
Service, you signify that you have read, understood, and agree to our collection,
storage, use, and disclosure of your personal information as described in this
Privacy Policy and our Terms of Service.</Text>

					 <Text className={'h2 m-t-2'}><span>Definitions and key terms </span> </Text>

					  <Text className={'p m-t-1'}> <span>To help explain things as clearly
as possible in this Privacy Policy, every time any of these terms <span
							 >are referenced</span>, are strictly defined as: </span> </Text>

					<ul  >
						<li><span>Cookie:
     small amount of data generated by a website and saved by your web browser.
     It is used to identify your browser, provide analytics,  <span>remember</span>
     information about you such as your language preference or login information. </span></li>
						<li ><span>Company:
     when this policy mentions “Company,” “we,” “us,” or “our,” it refers to <span
								 >UPD ,</span> (Yerevan, Armenia), that is responsible for your
     information under this Privacy Policy. </span></li>
						<li><span>Country:
     where https://sundaytowers.am/ or the owners/founders of https://sundaytowers.am/
     are based, in this case is Armenia </span></li>
						<li><span>Customer: refers to the
     company, organization or person that signs up to use the
     https://sundaytowers.am/ Service to manage the relationships with your
     consumers or service users. </span></li>
						<li><span>Device:
     any internet connected device such as a phone, tablet, computer or any
     other device that  <span>can be used</span> to visit
     https://sundaytowers.am/ and use the services. </span></li>
						<li><span>IP
     address: Every device connected to the Internet  <span>is
     assigned</span> a number known as an Internet protocol (IP) address. These
     numbers  <span>are usually assigned</span> in geographic
     blocks. An IP address  <span>can often be used</span> to
     identify the location from which a device is connecting to the Internet. </span></li>
						<li><span>Personnel:
     refers to those individuals who  <span>are employed</span> by
     https://sundaytowers.am/ or are under contract to perform a service on
     behalf of one of the parties. </span></li>
						<li><span>Personal
     Data: any information that directly, indirectly, or in connection with
     other information — including a personal identification number — allows
     for the identification or identifiability of a natural person. </span></li>
						<li><span>Service:
     refers to the service provided by https://sundaytowers.am/ as described in
     the relative terms (if available) and on this platform.  </span></li>
						<li><span>Third-party
     service: refers to advertisers, contest sponsors, promotional and marketing
     partners, and others who provide our content or whose products or services
     we think may interest you. </span></li>
						<li><span>Website:
     https://sundaytowers.am/’s site, which can be accessed via this URL:
     https://sundaytowers.am/ </span></li>
						<li><span>You:
     a person or entity that  <span>is registered</span> with
     https://sundaytowers.am/ to use the Services. </span></li>
					</ul>

					 <Text className={'h2 m-t-2'}><span>What Information Do We Collect? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We collect information from you
when you visit our website, register on our site, place an order, subscribe to
our newsletter, respond to a survey or fill out a form. </span> </Text>
					  <Text className={'p m-t-1'}><span></span> </Text>
					<ul  >
						<li><span>Name / Username </span></li>
						<li><span>Phone Numbers </span></li>
						<li><span>Email Addresses </span></li>
						<li><span>Mailing Addresses </span></li>
						<li><span>Age </span></li>
						<li><span>Password </span></li>
					</ul>

					  <Text className={'p m-t-1'}><span></span> </Text>

					 <Text className={'h2 m-t-2'}><span>When does https://sundaytowers.am/ use end user information from third
parties? </span> </Text>

					  <Text className={'p m-t-1'}> <span>https://sundaytowers.am/ will
collect End User Data necessary to provide the https://sundaytowers.am/
services to our customers. End users may voluntarily provide us with
information they have made available on social media websites. If you provide
us with any such information, we may collect publicly available information from
the social media websites you have indicated. You can control how much of your
information social media websites make public by visiting these websites and
changing your privacy settings. </span> </Text>

					  <Text className={'p m-t-1'}><span></span> </Text>

					 <Text className={'h2 m-t-2'}><span>When does https://sundaytowers.am/ use customer information from third
parties? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We receive some information from
the third parties when you contact us. For example, when you submit your email
address to us to show interest in becoming  <span>a</span>
https://sundaytowers.am/ customer, we receive information from a third party
that provides automated fraud detection services to https://sundaytowers.am/.
We also occasionally collect information that  <span>is made</span>
publicly available on social media websites. You can control how much of your
information social media websites make public by visiting these websites and
changing your privacy settings. </span> </Text>

					  <Text className={'p m-t-1'}> <span></span> </Text>

					 <Text className={'h2 m-t-2'}><span>Do we share the information we collect with third parties? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may share the information that
we collect, both personal and non-personal, with third parties such as
advertisers, contest sponsors, promotional and marketing partners, and others
who provide our content or whose products or services we think may interest
you. We may also share it with our current and future affiliated companies and
business partners, and if we are involved in a merger, asset sale or other
business reorganization, we  <span>may also</span> share or transfer
your personal and non-personal information to our successors-in-interest. </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may engage trusted third party
service providers to perform functions and provide services to us, such as hosting
and maintaining our servers and the website, database storage and management,
e-mail management, storage marketing, credit card processing, customer service
and fulfilling orders for products and services you may purchase through the
website. We will likely share your personal information, and possibly some
non-personal information, with these third parties to enable them to perform
these services for us and for you. </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may share portions of our log
file data, including IP addresses, for analytics purposes with third parties
such as web analytics partners, application developers, and ad networks. If
your IP address  <span>is shared</span>, it may be used to estimate
general location and other  <span>technographics</span> such as
connection speed, whether you have visited the website in a shared location,
and type of the device used to visit the website. They may aggregate
information about our advertising and what you see on the website and then
provide auditing, research and reporting for  <span>us and our
advertisers</span>. </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may also
disclose personal and non-personal information about you to government or law
enforcement officials or private parties as we, in our sole discretion, believe
necessary or appropriate in order to respond to claims, legal process
(including subpoenas), to protect our rights and interests or those of a third
party, the safety of the public or any person, to prevent or stop any illegal,
unethical, or legally actionable activity, or to otherwise comply with
applicable court orders, laws, rules and regulations.</span> </Text>

					 <Text className={'h2 m-t-2'}><span>Where and when  <span>is information collected</span> from
customers and end users? </span> </Text>

					  <Text className={'p m-t-1'}> <span>https://sundaytowers.am/ will
collect personal information that you submit to us. We may also receive
personal information about you from third parties as described above. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>How Do We Use The Information We Collect? </span> </Text>

					  <Text className={'p m-t-1'}> <span>Any of the information we collect
from you  <span>may be used</span> in one of the following ways:  </span> </Text>

					<ul  >
						<li><span>To
     personalize your experience (your information helps us to better respond
     to your individual needs) </span></li>
						<li><span>To
     improve our website (we continually strive to improve our website
     offerings based on the information and feedback we receive from you) </span></li>
						<li><span>To
     improve customer service (your information helps us to more effectively
     respond to your customer service requests and support needs) </span></li>
						<li><span>To
     process transactions </span></li>
						<li><span>To
     administer a contest, promotion, survey or other site feature </span></li>
						<li><span>To
     send periodic emails </span></li>
					</ul>

					 <Text className={'h2 m-t-2'}><span>How Do We Use Your Email Address? </span> </Text>

					  <Text className={'p m-t-1'}><span>By submitting your email address on this website, you agree to receive
emails from us.</span> <span> You can
cancel your participation in any of these email lists at any time by clicking
on the opt-out link or other unsubscribe option that is included in the
respective email. We only send emails to people who have authorized us to
contact them, either directly, or through a third party. We do not send unsolicited
commercial emails, because we hate spam as much as you do. By submitting your
email address, you also agree to allow us to use your email address for
customer audience targeting on sites like Facebook, where we display custom
advertising to specific people who have opted-in to receive communications from
us. Email addresses submitted only through the  <span>order
processing</span> page will be used for the sole purpose of sending you
information and updates pertaining to your order.  <span>If, however, you have provided the same email to us
through another method, we may use it for any of the purposes stated in this
Policy. Note: If at any time you would like to unsubscribe from receiving
future emails, we include detailed unsubscribe instructions at the bottom of each
email</span>. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>How Long Do We Keep Your Information? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We keep your information only so
long as we need it to provide https://sundaytowers.am/ to you and fulfill the
purposes described in this policy. This is also the case for anyone <span
							 >that we share your information with and who carries out services on
our behalf</span>. When we no longer need to use your information and there is
no need for us to keep it to comply with our legal or regulatory obligations, <span
							 >we’ll</span> either remove it from our systems or depersonalize it
so that we can't identify you. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>How Do We Protect Your Information? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We implement a variety of
security measures to maintain the safety of your personal information when you
place an order or enter, submit, or access your personal information. We offer
the use of a secure server. All supplied sensitive/credit information is
transmitted via Secure Socket Layer (SSL) technology and then encrypted into
our Payment gateway providers database only to be accessible by those
authorized with special access rights to such systems, and are required to keep
the information confidential. After a transaction, your private information
(credit cards, social security numbers, financials, etc.)  <span>is
never kept</span> on file. We cannot, however, ensure or warrant the absolute
security of any information you transmit to https://sundaytowers.am/ or
guarantee that your information on the Service  <span>may not be
accessed, disclosed, altered, or destroyed by a breach of any of our physical,
technical, or managerial safeguards</span>.  </span> </Text>

					  <Text className={'p m-t-1'}><span></span> </Text>

					 <Text className={'h2 m-t-2'}> <span>Could my information be transferred</span><span> to other countries? </span> </Text>

					  <Text className={'p m-t-1'}> <span>https://sundaytowers.am/ <span
						 >is incorporated</span> in Armenia.  <span>Information
collected via our website, through direct interactions with you, or from use of
our help services may be transferred from time to time to our offices or
personnel, or to third parties, located throughout the world, and may be viewed
and hosted anywhere in the world, including countries that may not have laws of
general applicability regulating the use and transfer of such data.</span> <span
						 >To the fullest extent</span> allowed by applicable law, by using
any of the above, you voluntarily consent to the trans-border transfer and
hosting of such information. </span> </Text>

					 <Text className={'h2 m-t-2'}> <span>Is the information collected</span><span> through
the https://sundaytowers.am/ Service secure? </span> </Text>

					  <Text className={'p m-t-1'}> <span>We take precautions to protect
the security of your information. We have physical, electronic, and managerial
procedures to help safeguard, prevent unauthorized access, maintain data
security, and correctly use your information. However, neither people nor
security systems are foolproof, including encryption systems. In addition,
people can commit intentional crimes, make mistakes or fail to follow policies.
Therefore, while we use reasonable efforts to protect your personal
information, we cannot guarantee its absolute security. If applicable law
imposes any non- <span>disclaimable</span> duty to protect your
personal information, you agree that intentional misconduct will be the
standards used to measure our compliance with that duty. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Can I update or correct my information? </span> </Text>

					  <Text className={'p m-t-1'}> <span>The rights you have to request
updates or corrections to the information https://sundaytowers.am/ collects
depend on your relationship with https://sundaytowers.am/. Personnel may update
or correct their information as detailed in our internal company employment policies. </span> </Text>

					  <Text className={'p m-t-1'}> <span>Customers have the right to
request the restriction of certain uses and disclosures of personally
identifiable information as follows. You can contact us in order to (1) update
or correct your personally identifiable information, (2) change your preferences
with respect to communications and other information you receive from us, or
(3) delete the personally identifiable information maintained about you on our
systems (subject to the following paragraph), <span>by cancelling your account</span>. Such updates, corrections,
changes and deletions will have no effect on other information that we
maintain, or information that we have provided to third parties in accordance
with this Privacy Policy prior to such update, correction, change or deletion.
To protect your privacy and security, we may take reasonable steps (such as
requesting a unique password) to verify your identity before granting you
profile access or making corrections. You are responsible for maintaining the
secrecy of your unique password and account information at all times. </span> </Text>

					  <Text className={'p m-t-1'}> <span>You should be aware that it is
not technologically possible to remove  <span>each and every</span>
record of the information you have provided to us from our system. The need to
back up our systems to protect information from inadvertent loss means that a
copy of your information may exist in a non-erasable form that will be
difficult or impossible for us to locate. Promptly after receiving your
request, all personal information stored in databases we actively use, and
other readily searchable media will be updated, corrected, changed or deleted,
as appropriate, as soon as and to the extent reasonably and technically
practicable. </span> </Text>

					  <Text className={'p m-t-1'}> <span>If you are an end user and wish
to update, delete, or receive any information we have about you, you may do so
by contacting the organization of which you are a customer. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Personnel </span> </Text>

					  <Text className={'p m-t-1'}> <span>If you are  <span>a</span>
https://sundaytowers.am/ worker or applicant, we collect information you
voluntarily provide to us. We use the information collected for Human Resources
purposes in order to administer benefits to workers and screen applicants. </span> </Text>

					  <Text className={'p m-t-1'}> <span>You may contact us in order to
(1) update or correct your information, (2) change your preferences with
respect to communications and other information you receive from us, or (3)
receive a record of the information we have relating to you. Such updates,
corrections, changes and deletions will have no effect on other information
that we maintain, or information that we have provided to third parties in
accordance with this Privacy Policy prior to such update, correction, change or
deletion. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Sale of Business </span> </Text>

					  <Text className={'p m-t-1'}> We reserve the
right to transfer information to a third party in the event of a sale, merger
or other transfer of all or substantially all of the assets of
https://sundaytowers.am/ or any of its Corporate Affiliates (as defined
herein), or that portion of https://sundaytowers.am/ or any of its Corporate
Affiliates to which the Service relates, or in the event that we discontinue
our business or file a petition or have filed against us a petition in
bankruptcy, reorganization or similar proceeding, provided that the third party
agrees to adhere to the terms of this Privacy Policy. </Text>

					 <Text className={'h2 m-t-2'}><span>Affiliates </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may disclose information
(including personal information) about you to our Corporate Affiliates. For
purposes of this Privacy Policy, &quot;Corporate Affiliate&quot; means any
person or entity which directly or indirectly controls, is controlled by or is
under common control with https://sundaytowers.am/, whether by ownership or
otherwise.  <span>Any information relating to you that we provide to
our Corporate Affiliates will be treated by those Corporate Affiliates in
accordance with the terms of this Privacy Policy</span>. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Governing Law </span> </Text>

					  <Text className={'p m-t-1'}> <span>This Privacy
Policy is governed by the laws of Armenia without regard to its conflict of
laws provision</span> <span>.  </span> </Text>

					  <Text className={'p m-t-1'}> <span>The laws of Armenia shall govern
this Agreement and your use of the website. Your use of the website may also be
subject to other local, state, national, or international laws. </span> </Text>

					  <Text className={'p m-t-1'}> <span>By using https://sundaytowers.am/
or contacting us directly, you signify your acceptance of this Privacy Policy.
If you do not agree to this Privacy Policy, you should not engage with our
website, or use our services. Continued use of the website, direct engagement
with us, or following the posting of changes to this Privacy Policy that do not
significantly affect the use or disclosure of your personal information will
mean that you accept those changes. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Your Consent </span> </Text>

					  <Text className={'p m-t-1'}> <span>We've</span> updated our Privacy Policy to
provide you with complete transparency into what is being set when you visit
our site and how it's being used. By using our https://sundaytowers.am/,
registering an account, or making a purchase, you hereby consent to our Privacy
Policy and agree to its terms.</Text>

					 <Text className={'h2 m-t-2'}><span>Links to Other Websites </span> </Text>

					  <Text className={'p m-t-1'}><span>This Privacy Policy applies only to the Services. The Services may contain
links to other websites not operated or controlled by https://sundaytowers.am/.
We are not responsible for the content, accuracy or opinions expressed in such
websites, and such websites  <span>are not investigated, monitored
or checked for accuracy or completeness by us</span>. Please remember that when
you use a link to go from the Services to another website, our Privacy Policy
is no longer in effect.  <span>Your</span> browsing and interaction
on any other website, including those that have a link on our platform, is
subject to that website’s own rules and policies. Such third parties may use
their own cookies or other methods to collect information about you.</span><span
						   > </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Cookies </span> </Text>

					  <Text className={'p m-t-1'}> <span>https://sundaytowers.am/ uses
						&quot;Cookies&quot; to identify the areas of our website that you have visited.
A Cookie is a small piece of data stored on your computer or mobile device by
your web browser. We use Cookies to enhance the performance and functionality
of our website but are non-essential to their use. However, without these
cookies, certain functionality like videos may become unavailable or you would
be required to enter your login details every time you visit the <span
							 >website</span> as we would not be able to remember that you had
logged in previously. Most web browsers can be set to disable the use of
Cookies. However, if you disable Cookies, you may not be able to access
functionality on our website correctly or at all. We never place Personally
Identifiable Information in Cookies.  </span> </Text>

					  <Text className={'p m-t-1'}> <span></span> </Text>

					 <Text className={'h2 m-t-2'}><span>Blocking and disabling cookies and similar technologies </span> </Text>

					  <Text className={'p m-t-1'}> <span>Wherever  <span>you're</span>
located you may also set your browser to block cookies and similar
technologies, but this action may block our essential cookies and prevent our
website from functioning properly, and you may not be able to fully utilize all
of its features and services. You should also be aware that you may also lose
some saved information (e.g. saved login details, site preferences) if you
block cookies on your browser. Different browsers make different controls
available to you. Disabling a cookie or category of cookie does not delete the
cookie from your browser, you will need to do this yourself from within your
browser,  <span>you</span> should visit your browser's help menu for
more information. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Kids' Privacy </span> </Text>

					  <Text className={'p m-t-1'}> <span>We collect information from kids
under the age of 13 just to better our services. If  <span>You</span>
are a parent or guardian and You are aware that Your child has provided Us with
Personal Data without your permission, please contact Us. If  <span>We</span>
become aware that We have collected Personal Data from anyone under the age of
13 without verification of parental consent, We take steps to remove that
information from Our servers. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Changes  <span>To</span> Our Privacy Policy </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may change our Service and
policies, and we may need to make changes to this Privacy Policy so that they
accurately reflect our Service and policies. Unless otherwise required by law,
we will notify you (for example, through our Service) before we make changes to
this Privacy Policy and give you an opportunity to review them before they go
into effect. Then, if you continue to use the Service,  <span>you
will be bound by the updated Privacy Policy</span>. If you do not want to agree
to this or any updated Privacy Policy, you can delete your account. </span> </Text>

					 <Text className={'h2 m-t-2'}><span>Third-Party Services </span> </Text>

					  <Text className={'p m-t-1'}> <span>We may display, include or make
available third-party content (including data, information, applications and
other products services) or provide links to third-party websites or services
(&quot;Third- Party Services&quot;). </span> </Text>

					  <Text className={'p m-t-1'}> <span>You acknowledge and agree that
https://sundaytowers.am/ shall not be responsible for any Third-Party Services,
including their accuracy, completeness, timeliness, validity, copyright
compliance, legality, decency, quality or any other aspect thereof.
https://sundaytowers.am/ does not assume and shall not have any liability or
responsibility to you or any other person or entity for any Third-Party
Services. </span> </Text>

					  <Text className={'p m-t-1'}> <span>Third-Party Services and links
thereto  <span>are provided</span> solely as a convenience to you
and you access and use them entirely at your own risk and subject to such third
parties' terms and conditions. </span> </Text>

					 <Text className={'h2 m-t-2'}>Tracking Technologies</Text>

					  <Text className={'h4 m-t-1'}>Google Maps API</Text>

					  <Text className={'p m-t-1'}>Google Maps API is a robust tool that can be used
to create a custom map, a searchable map, check-in functions, display live data
synching with location, plan routes, or create a mashup just to name a few.</Text>

					  <Text className={'p m-t-1'}> <span>Google Maps API may collect information from <span
						 >You</span> and from Your Device for security purposes. </span> </Text>

					  <Text className={'p m-t-1'}> <span>Google Maps API collects information that <span
						 >is held</span> in accordance with its Privacy Policy </span> </Text>

					  <Text className={'h4 m-t-1'}>Cookies</Text>

					  <Text className={'p m-t-1'}> <span>We use Cookies to enhance the performance and
functionality of our platform but are non-essential to their use. However,
without these cookies, certain functionality like videos may become unavailable
or you would be required to enter your login details every time you visit the <span>platform</span> as we would not be able to remember that you had
logged in previously. </span> </Text>

					  <Text className={'h4 m-t-1'}>Local Storage</Text>

					  <Text className={'p m-t-1'}><span>Local Storage sometimes known as DOM <span
						 >storage,</span> provides web apps with methods and protocols for
storing client-side data. Web storage supports persistent data storage, similar
to cookies but with a greatly enhanced capacity and no information stored in the
HTTP request header.</span> <span> </span> </Text>

					 <Text className={'h2 m-t-2'}>Contact Us</Text>

					  <Text className={'p m-t-1'}><span>Don't</span><span
						   > hesitate to contact us if you have any
questions. </span> </Text>


					<ul>
						<li>Via Email: info@upd.am </li>
					</ul>

				</Container>
		</PrivacyPolicyStyle>
</Page>
);
});

export default withUIContext(withDataContext(PrivacyPolicyTemplate, ['setPartners']), ['updatePageResize', 'updatePageResizeState']);
